import SuccessModal from '~/components/modals/SuccessModal.vue'

const overlay = useOverlay()
export const successModal = overlay.create(SuccessModal)

export const modal = {
  successModal,
}
